import { Text } from '@thefarmersfront/kitchen';

import { DialogMessage } from '~/components/common';

/**
 * [입고관리 > 입고요청관리] 일부 건이 입고요청 취소 가능
 */
const DialogPartialCancelable = () => {
  return (
    <DialogMessage
      mainMessage={
        <>
          <Text size="large">{'선택하신 항목 중 취소 가능한 건만 입고 취소가\n진행됩니다.\n취소 가능 조건:'}</Text>
          <div>
            <Text element="span" size="large" weight="semi-bold">
              [요청완료]{' '}
            </Text>
            <Text element="span" size="large">
              상태: 취소 기한 제한 없음
            </Text>
          </div>
          <div>
            <Text element="span" size="large" weight="semi-bold">
              [확인완료]{' '}
            </Text>
            <Text element="span" size="large">
              상태: 입고일 하루 전(D-1) 17시까지
            </Text>
          </div>
        </>
      }
      captionMessage={
        <>
          <Text element="span" size="medium" weight="semi-bold" color="tertiary">
            [확인완료]
          </Text>
          <Text element="span" size="medium" color="tertiary">
            {'의 입고일 D-1일 17시 이후인 건에 대해\n취소하고자 하는 경우 컬리에 별도 문의해 주세요.'}
          </Text>
        </>
      }
    />
  );
};

export default DialogPartialCancelable;
